import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_367: DocMigration = {
  maxSchemaVersion: "0.0.367",
  description: "Adds the floor materials plan and floor summary plan annotation tags to old files",
  apply(json: any) {
    json.entityTags["addToFloorMaterialsPlan"] = entityTagNew({
      id: "addToFloorMaterialsPlan",
      name: "Add To Floor Materials Plan",
    });
    json.entityTags["addToFloorSummaryPlan"] = entityTagNew({
      id: "addToFloorSummaryPlan",
      name: "Add To Floor Summary Plan",
    });

    return json;
  },
};

function entityTagNew({ id = uid(), name = "Entity Tag" }): EntityTag {
  return {
    entityType: "ENTITY_TAG",
    id,
    name,
    sortIndex: 0,
  };
}

interface EntityTag {
  readonly entityType: "ENTITY_TAG";
  readonly id: string;
  readonly name: string;
  readonly sortIndex: number;
}

export default migration_0_0_367;
